import { DomainEvent } from "@/domains/events"

export class WalletConnectedEvent extends DomainEvent {
  static readonly TYPE = "wallet.connected"
  readonly type = WalletConnectedEvent.TYPE
  constructor(public readonly address: string) {
    super()
  }
}

export class WalletDisconnectedEvent extends DomainEvent {
  static readonly TYPE = "wallet.disconnected"
  readonly type = WalletDisconnectedEvent.TYPE
  constructor(public readonly address: string) {
    super()
  }
}
